import { View, Platform } from "react-native";
const isMobile = ['ios', 'android'].includes(Platform.OS)

export default () => <View style={{
    paddingTop: (13 * 4) + (isMobile ? 8 : 0),
    paddingBottom: (13 * 4) + (isMobile ? 8 : 0),
    paddingLeft: 18 + 4
}} />